module.exports = __webpack_public_path__ + "static/img/17jiayou.2bb4f6ec.gif";